import { useFileLoaded } from "@/app/hooks/useFileLoad";
import { Message, RiskStatus } from "@/app/store/types";
import { parseFileData } from "@/app/utils/file";
import { useRef } from "react";
import styles from "./Audio.module.scss";
import { isMobileDevice } from "@/app/utils/device";
import Locale from "@/app/locales";

export default function Audio({ msg }: { msg: Message }) {
  const videoRef = useRef(null);
  const content = msg.content as string;

  const { onload, onError } = useFileLoaded(msg);

  if (msg.riskStatus === RiskStatus.Failed) {
    return <div>{Locale.riskMsg.forbidden}</div>;
  }

  return (
    <audio
      onError={onError}
      ref={videoRef}
      src={parseFileData(content)?.fileUrl}
      controls
      className={`${styles.audio} ${isMobileDevice() ? styles.mobile : ""}`}
      onLoad={onload}
    />
  );
}
